import styled from 'styled-components';

export const QuantityContainer = styled.div`
  margin: 20px auto;
  max-width: 350px;
`;
